import getConfig from 'next/config';
import React from 'react';

import { ConfigContext, IConfig } from './ConfigContext';

const runtimeConfig: IConfig = {
  gatewayUrl: getConfig().publicRuntimeConfig.gatewayUrl,
  publicUrl: getConfig().publicRuntimeConfig.publicUrl,
  environment: getConfig().publicRuntimeConfig.environment,
};

const ConfigProvider = ({ children }) => (
  <ConfigContext.Provider value={runtimeConfig}>{children}</ConfigContext.Provider>
);

export default ConfigProvider;
